import type {
  Booking,
  BookingsApiOptions,
  BookingsApiPayload,
} from '@brighterly/lib-core-types/booking/interfaces'

import { SortDirection } from '@brighterly/lib-core-types/options/enums'

import { useBookingStore } from '@stores/booking'

import { useCsRoutes } from '@composables/routes/cs-route.hook'

import { listPaidBookingRequestStatuses } from '@config/booking'
import { pick } from '@helpers/object'

export const useBookingsApiPaid = async (payload: BookingsApiPayload, options?: BookingsApiOptions): Promise<Booking[] | null> => {
  const { $axios } = useNuxtApp()

  const url = useCsRoutes('bookings', pick({
    '[discipline_id]': payload.disciplineId,
    status: listPaidBookingRequestStatuses,
    with_delayed_canceled: 1,
    sort_by: ['start', 'id'],
    sort_direction: SortDirection.Asc,
    from: payload.from,
    to: payload.to,
  }))

  const bookingStore = useBookingStore()

  options?.onStart?.()

  if (!payload.skipStore) {
    if (!payload.background) {
      bookingStore.setLoading(true)
      bookingStore.setBookings(null)
      bookingStore.setCountdown(null)
    } else {
      if (!bookingStore.isLoadingDone) {
        bookingStore.setLoading(true)
        bookingStore.setBookings(null)
        bookingStore.setCountdown(null)
      }
    }
  }

  try {
    const { data } = await $axios.get(url!)
    const bookings = data.data?.data || []

    if (!payload.skipStore) {
      bookingStore.setBookings(bookings)
      bookingStore.setLoading(false)
      bookingStore.setLoadingDone(true)
      bookingStore.setBookingTrigger()
    }

    options?.onSuccess?.(bookings)
    return bookings
  } catch (err) {
    console.error(err)

    if (!payload.skipStore) {
      bookingStore.setBookings(null)
      bookingStore.setLoadingDone(false)
    }
    return null
  }
}
